if(!customElements.get("currency-switcher")){
  class CurrencySwitcher extends HTMLElement {
    constructor(){
      super();
      this.initSelect();
      this.checkLocalStorage();
      this.selectedCurrency = "";
      this.currencyData = {};
    }
    initSelect(){
      const select = this.querySelector("select");
      select.value = localStorage.getItem("selectedCurrency") || "TRY";
      select.addEventListener("change", (e)=> {
        this.selectedCurrency = e.target.value;
        localStorage.setItem("selectedCurrency", this.selectedCurrency);
        this.checkLocalStorage();
      })
    }
    checkLocalStorage(){
      // If no selected currency, set it to TRY
      if(localStorage.getItem("selectedCurrency")){
        this.selectedCurrency = localStorage.getItem("selectedCurrency");
      } else {
        this.selectedCurrency = "TRY";
        localStorage.setItem("selectedCurrency", this.selectedCurrency);
      }
      // If no currency data, update it
      if(localStorage.getItem("currencyData")){
        this.currencyData = JSON.parse(localStorage.getItem("currencyData"));
      } else {
        this.updatePrices();
        return;
      }
      // If no update time, update it
      if(localStorage.getItem("currencyUpdateTime")){
        const updateTime = moment(localStorage.getItem("currencyUpdateTime"));
        // If update time is before 1 day, update it
        if(updateTime.isBefore(moment().subtract(1, "day"))){
          localStorage.removeItem("currencyUpdateTime");
          this.updatePrices();
          return;
        }
      } else {
        this.updatePrices();
        return;
      }
      this.initPrices();
    }
    async updatePrices() {
      const response = await fetch("https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/try.json");
      if(!response.ok){
        this.activeCurrency = "TRY";
        window.currencySelector = {
          name: "TRY",
          rate: 1,
          symbol: "TL",
        }
        this.remove();
        return;
      }
      const data = await response.json();
      console.log(data);
      if(data.try){
        localStorage.setItem("currencyUpdateTime", moment().toISOString());
        localStorage.setItem("currencyData", JSON.stringify(data.try));
        this.currencyData = data.try;
      }
      this.initPrices();
    }
    initPrices(){
      console.log(this.selectedCurrency);
      console.log(this.currencyData);
      window.currencySelector = {
        name: this.selectedCurrency,
        rate: this.currencyData[this.selectedCurrency.toLowerCase()],
      }
      if(this.selectedCurrency === "TRY"){
        window.currencySelector.symbol = "TL";
      } else if (this.selectedCurrency === "USD"){
        window.currencySelector.symbol = "$";
      } else if (this.selectedCurrency === "EUR"){
        window.currencySelector.symbol = "€";
      }
      window.initDatesAndPrices();
    }
  }
  customElements.define("currency-switcher", CurrencySwitcher);
}
